import $ from 'jquery';
import slick from 'slick-carousel';

$( ".c-hero-slider" ).slick( {
	infinite: true,
	slidesToShow: 1,
	dots: true,
	arrows: false,
	rows: 0,
} );
